import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Products } from "../Model/Products";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface GetProducstUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<Products>>;
}

export class GetProducts implements GetProducstUseCase {
  private productRepo: OffersPromoRepository;
  constructor(_ProductRepo: OffersPromoRepository) {
    this.productRepo = _ProductRepo;
  }

   invoke(page: number, pageSize: number, search: string){
    const getData = this.productRepo.getProducts(page, pageSize, search);
    return getData;
  }
}